export const environment = {
  production: true,
  api: {
    apiV1: 'https://api.newxlife.xl.co.id/prod',
    baseUrl: 'https://api.newxlife.xl.co.id/prod/ewp',
    appId: '60d5e2fbd48f26701a09d5dd',
  },
  BO_URL: 'https://admin.newxlife.xlsmart.co.id',
  EMR_ADMIN_URL: 'https://mradmin.newxlife.xlsmart.co.id',
  EWP_ADMIN_URL: 'https://ewp.newxlife.xlsmart.co.id',
  foURL: 'https://www.newxlife.xlsmart.co.id/en/',
  baseUrl: 'https://ewp.newxlife.xlsmart.co.id',
  gtag: 'G-S7Q9TVD2NX',

  azure: {
    clientId: 'ce33cbbd-66ef-48cc-88fc-65a28fdaa4bf',
    authority:
      'https://login.microsoftonline.com/a1eae0da-f0d1-449d-8854-f54ddbda8711',
  },
};
